import * as React from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";

export default function FormFooter({ onCancel, isSave = false }) {
  const history = useHistory();
  const onClickCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      history.push("/private/properties");
    }
  };

  return (
    <Stack
      spacing={2}
      direction="row"
      justifyContent="flex-end"
      sx={{ padding: "2rem 0 0 0" }}
    >
      <Button onClick={onClickCancel}>Cancel</Button>
      <Button type="submit" variant="contained">
        {isSave ? "Save" : "Continue"}
      </Button>
    </Stack>
  );
}
